// export const url = "http://localhost/nomina"
// export const url2 = "http://localhost/lvl-nominaB/public/api"
    export const url = "https://nominamina.ginga.com.co/nomina"
    export const url2 = "https://nominamina.ginga.com.co/lvl-nominaB/public/api"